export default __webpack_public_path__ + "product_catalogue.pdf";